import { render, staticRenderFns } from "./CommonNews.vue?vue&type=template&id=39ab80b8&scoped=true"
import script from "./CommonNews.vue?vue&type=script&lang=js"
export * from "./CommonNews.vue?vue&type=script&lang=js"
import style0 from "./CommonNews.vue?vue&type=style&index=0&id=39ab80b8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ab80b8",
  null
  
)

export default component.exports